export type GlobalBannerSlot = 'banner-1' | 'banner-2';

export const DUAL_BANNER_SLOTS: readonly GlobalBannerSlot[] = ['banner-1', 'banner-2'];

export interface ImageSource {
  srcset: string;
  media?: string;
  width?: number;
  height?: number;
  aspectratio?: string;
}

export interface PrimaryMedia {
  src: string;
  alt: string;
  sources: ImageSource[];
}

export interface BannerLink {
  href: string;
  text?: string;
  gae: string;
}

export interface GlobalBannerContentConfig {
  color?: string;
  ctaLayoutDirection?: 'vertical' | 'horizontal';
  desktopPaddingX?: number;
  desktopPaddingY?: number;
  mobilePaddingX?: number;
  mobilePaddingY?: number;
  ctaSpacing?: 'grouped' | 'spacedBetween' | 'spacedEvenly';
  ctalinks?: BannerLink[];
  position?: string;
  shouldFillHeight?: boolean;
  shouldFillWidth?: boolean;
}

export interface GlobalBannerSlotContent {
  creativeID: string;
  componentName: string;
  containerBreak?: boolean;
  content?: GlobalBannerContentConfig;
  links: BannerLink[];
  media: {
    primary: PrimaryMedia;
  };
}

export interface DualGlobalBannerData {
  slotData?: Partial<Record<GlobalBannerSlot, GlobalBannerSlotContent>>;
}

export interface GlobalBannerProps {
  banner: GlobalBannerSlotContent;
  slot: GlobalBannerSlot;
  testId?: string;
  pageType?: string;
  sessionId: string;
}
